import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false
Vue.prototype.$url = 'https://www.abacloud.com.mx:444/abacloudserver'
// Vue.prototype.$url = 'http://201.77.108.20:4000/abacloudserver'
// Vue.prototype.$url = 'http://177.238.248.42:4000/abacloudserver'
// Vue.prototype.$url = 'http://localhost:5002'
// Vue.prototype.$url = 'http://192.168.0.98:5002'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
